import { render } from "./reporte_vendedores_ventas.vue?vue&type=template&id=054face4&scoped=true"
import script from "./reporte_vendedores_ventas.vue?vue&type=script&lang=js"
export * from "./reporte_vendedores_ventas.vue?vue&type=script&lang=js"

import "./reporte_vendedores_ventas.vue?vue&type=style&index=0&id=054face4&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054face4"]])

export default __exports__